import { useMemo } from 'react';
import { useQuery } from 'utils/react-query';
import queries from 'containers/Managers/queries';

import { PRIVACY_ATTRIBUTE_IDS } from 'constants/index';

import usePageContext from './usePageContext';

export const useManagerConnections = ({ enabled = true } = {}) => {
  const { entityId } = usePageContext();

  return useQuery(
    queries.getManagerConnections({
      id: entityId,
      filters: {
        privacy_attribute_id: [
          PRIVACY_ATTRIBUTE_IDS.PRIVATE,
          PRIVACY_ATTRIBUTE_IDS.PUBLIC,
          PRIVACY_ATTRIBUTE_IDS.CASTING_TOOL,
          PRIVACY_ATTRIBUTE_IDS.AGENCY,
          PRIVACY_ATTRIBUTE_IDS.AOS,
          PRIVACY_ATTRIBUTE_IDS.ARTIST,
          PRIVACY_ATTRIBUTE_IDS.FREE_AND_PRO,
        ],
      },
      queryConfig: { select: response => response?.data, enabled: enabled && !!entityId, keepPreviousData: true },
    }),
  );
};

export const useManagerAgreements = ({ enabled = true } = {}) => {
  const { data: connections } = useManagerConnections();
  const connectionIds = useMemo(() => connections?.map(connection => connection?.id), [connections]);

  return useQuery(
    queries.getConnectionsAgreements({
      ids: connectionIds,
      queryConfig: { select: response => response?.data, enabled: enabled && connectionIds?.length > 0 },
    }),
  );
};
